module.exports = __webpack_public_path__ + "static/media/s6.06bf639e.png";